<!-- 予約/購入エラー -->
<template>
  <TemplateMfittBookingError />
</template>

<script>
import TemplateMfittBookingError from "@/views/Templates/MFITT/TemplateMfittBookingError";

import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

export default {
  name: "MfittBookingError",
  components: {
    TemplateMfittBookingError,
  },
  setup() {},
};
</script>
